import { css } from "@emotion/react";

export const indexWrapCss = css`
    padding: 0 0;
    margin: 0 auto;
    display: flex;
    background-color: white;
    flex-direction: column;
    overflow-x: hidden;
`;

export const widthCss = css`
  /*  margin: 0 auto;*/
    display: flex;
    min-width: 1200px;
    padding: 120px 0px;
    flex-direction: column;
    justify-content: center;
    
    .bookWrap {
        display: flex;
        flex-direction: column;
        align-items: flex-start;
        gap: 90px;
        align-self: stretch;
    }
    
    .bookDesc {
        width:100%;
        margin : 0 auto;
        max-width: 1200px;
    }
    
    .indexCss{
        width:100%;
        margin : 0 auto;
        max-width: 1200px; 
        
    }



    
`;


export const BookstoryMobileCss = css`
    margin: 0 auto;
    display: flex;
    min-width: 320px;
    max-width: 640px;
    padding: 20px 0px;
    flex-direction: column;
    justify-content: center;
    width:100%;
    gap: 90px;
    box-sizing: border-box;

    .slick-slide {
        gap:100px;
        margin: 0 6px; /* 좌우 간격을 추가 */
    }



`;


export const BookstroyCss = css`

    margin: 0 auto;
    display: flex;
    min-width: 1200px;
    max-width: 1200px;
    padding: 85px 0px;
    flex-direction: column;
    justify-content: center;
    width:100%;
    gap: 60px;
    
    .title {
        
        
        p {
            color: #333;
            text-align: center;
            font-size: 36px;
            font-style: normal;
            font-weight: 700;
            line-height: 60px;
        }
        
        span {
            display: block;
            color: #333;
            text-align: center;
            font-size: 28px;
            font-style: normal;
            font-weight: 400;
            line-height: 60px;;
        }
        
       
    }

    .sildeBook {
        display: flex;
        flex-direction: row;  
        justify-content: center;  
        gap: 8px; 
        max-width: 1000px;  
        width: 100%;
        align-items: center;  
        margin: 0 auto;  
    }
    
    .book {
        width: 157px;
        height: 222px;
        flex-shrink: 0;
       
    }
    
    .slick-slider {
        width: 100%;
    }
    
    .slick-slide {
        gap:100px;
        margin: 0 15px; /* 좌우 간격을 추가 */
    }
    

`;


export const BookPubliCss = css`
    display: flex;
    flex-direction: column;
   /* align-items: center;*/
    gap: 60px;
    align-self: stretch;
    /*padding: 120px 0px;*/
    max-width: 1200px;
    margin: 0 auto;
    
    
    .genre {
        display: flex;
        width: 468px;
        padding: 4px 0px;
        justify-content: center;
        align-items: center;
        align-content: center;
        gap: 40px;
        flex-wrap: wrap;
    }
    
    .genreBtn {
        display: flex;
        min-width: 76px; 
        height: 40px;
        padding: 10px 24px;
        justify-content: center;
        align-items: center;
        gap: 5px;
        flex-shrink: 0;
        border-radius: 30px;
        box-shadow: 2px 2px 4px 0px rgba(0, 0, 0, 0.16);
        cursor: pointer;
        transition: background-color 0.3s ease, color 0.3s ease;
    }
    
    .publiList {
        display: flex;
        align-items: flex-start;
        align-content: flex-start;
        gap: 60px 21px;
        align-self: stretch;
        flex-wrap: wrap;
    }
    
    .publiItem {
        display: flex;
        align-items: center;
        gap: 20px;
    }
    
    .publiReason {
        display: flex;
        flex-direction: column;
        width: 342px;
        height: 200px;
        padding: 73px 39px;
        justify-content: center;
        align-items: center;
        gap: 20px;
        border-radius: 6px;
        border: 1px solid #D0D0D0;
        background: #FFF;
    }
    .publiImg {
        width: 207px;
        height: 280px;
        flex-shrink: 0;
        border-radius: 6px;
        display: flex;
        align-items: center;
        justify-content: center;
      
    }

    .publiImg img {
        max-width: 100%;
        max-height: 100%;
        width: auto;
        height: auto;
        object-fit: cover;
    }



`;


export const bookIntroCss = css`
    display: flex;
    padding: 50px 60px 50px 60px;
    flex-direction: column;
/*    min-height: 700px;*/
    align-items: flex-start;
    margin: 0 auto;
    max-width: 1200px;
    width: 100%;
    gap: 0;
    align-self: stretch;
    border-radius: 24px;
    background: linear-gradient(149deg, #f1f5f2 0%, #e8f5ee 100%);
    overflow: hidden;

    .introWrap {
        display: flex;
        flex-direction: row;
        flex-shrink: 0;
        border-radius: 16px;
        width: 100%;
        gap: 72px;
        align-items: flex-start;
    }

    .bookImg {
        display: flex;
        justify-content: center;
        align-items: flex-start;
        flex-shrink: 0;
        width: 340px;
        height: 510px;
    }

    .bookImg img {
        width: 100%;
        height: 100%;
        object-fit: cover;
        border-radius: 16px;
        box-shadow: 0px 27px 80px 0px rgba(0,0,0,0.25);
    }

    .infoWrap {
        display: flex;
        flex-direction: column;
        flex: 1;
        padding-top: 20px;
    }

    .bookTitle {
        color: #14213D;
        font-size: 56px;
        font-style: normal;
        font-weight: 700;
        line-height: 1.2;
        margin-top: 0;
    }

    .genre {
        display: flex;
        height: 44px;
        min-width: 72px;
        padding: 7px 16px;
        justify-content: center;
        align-items: center;
        gap: 8px;
        border-radius: 12px;
        border: 1px solid #19CF7A;
        background: #FFF;
        color: #19CF7A;
        text-align: center;
        box-shadow: 0 1px 3px 0 rgb(0 0 0 / 0.1);
        font-family: SeoulNamsan-B;
        font-size: 20px;
        font-style: normal;
        font-weight: 400;
        line-height: normal;
    }
    .authorName {
        color: #4F556D;
        font-family: SeoulNamsan-EB;
        font-size: 26px;
        font-style: normal;
        font-weight: 400;
        line-height: 36px;
    }

    .authorResonTilte {
        color: #4F556D;
        font-family: SeoulNamsan-EB;
        font-size: 22px;
        font-style: normal;
        font-weight: 400;
        line-height: 34px;
    }

    .authorReson {
        width: 100%;
        max-width: 740px;
        display: flex;
        min-height: 100px;
        padding: 20px 28px;
        justify-content: flex-start;
        align-items: flex-start;
        gap: 8px;
        align-self: stretch;
        border-radius: 32px;
        border: 1px solid rgba(74, 222, 153, 0.3);
        background: rgba(255,255,255,0.7);
        color: #333;
        font-family: SeoulNamsanM;
        font-size: 18px;
        font-style: normal;
        font-weight: 400;
        line-height: 32px;
        box-shadow: 0px 13px 20px 0px rgba(0,0,0,0.08), 0px 5px 8px 0px rgba(0,0,0,0.08);
        text-align: left;
    }
    .awardTilte {
        color: #657970;
        font-size: 20px;
        font-style: normal;
        font-weight: 700;
        line-height: 34px;
    }

    .awardDate {
        color: #657970;
        font-size: 16px;
        font-style: normal;
        font-weight: 500;
        line-height: 34px;
    }
    
    @media (max-width: 380px) {
        display: flex;
        flex-direction: column;
        align-items: flex-start;
        gap: 8px;
        width: 100%;
        padding: 20px 16px;
        align-self: stretch;
        height: auto;
        border-radius: 0;
        box-sizing: border-box;
        
        .introWrap {
            flex-direction: column;
            gap: 24px;
            width: 100%;
        }

        .bookImg {
            display: flex;
            align-items: center;
            justify-content: center;
            width: 100%;
            max-width: 200px;
            margin: 0 auto;
            height: auto;
            aspect-ratio: 2 / 3;
            flex-shrink: 0;
        }

        .infoWrap {
            display: flex;
            flex-direction: column;
            align-items: flex-start;
            gap: 6px;
            margin: 0 auto;
            align-self: stretch;
            width: 100%;
        }

        .bookTitle {
            color: #14213D;
            font-size: 24px;
            font-style: normal;
            font-weight: 700;
            line-height: normal;
        }

        .genre {
            display: flex;
            padding: 4px 12px;
            justify-content: center;
            align-items: center;
            gap: 8px;
            font-size: 14px;
            font-style: normal;
            font-weight: 400;
            line-height: normal;
            height: 20px;
            border-radius: 4px;
            min-width: 42px;
        }
        
        .authorName {
            font-size: 16px;
            font-style: normal;
            font-weight: 400;
            line-height: normal;
        }

        .authorResonTilte {
            font-size: 16px;
            font-style: normal;
            font-weight: 400;
            line-height: normal;
        }


        .authorReson {
            width: 100%;
            display: flex;
            padding: 20px 14px;
            justify-content: flex-start;
            align-items: flex-start;
            text-align: left;
            gap: 8px;
            align-self: stretch;
            border-radius: 12px;
            border: 1px solid #4ADE99;
            background: #FCFCFC;
            color: #333;
            font-family: SeoulNamsanM;
            font-size: 14px;
            font-style: normal;
            font-weight: 400;
            line-height: 24px; 
            box-sizing: border-box;
        }
        
    }
    
`;

export const keywordCss = css`
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    gap: 12px;
    margin : 0 auto;
    align-self: stretch;
    
`;

export const bookDescCss = css`
    display: flex;
    flex-direction: column;
    gap: 12px;
    width:100%;
    margin : 0 auto;
    max-width: 1200px;
    align-self: stretch;


`;


export const addBookWidthCss = css`
    margin: 0 auto;
    display: flex;
    width: 100%;
    min-width: 1200px;
    padding: 120px 0px;
    align-items: flex-start;
    gap: 60px;
    flex-direction: column;

   /* @media (max-width: 768px) {
        padding: 0 20px;
        margin: 0 auto;
        display: flex;
        flex-direction: column;
    }*/
    
`;

export const titleCss = css`
    color: #000;
    font-size: 32px;
    font-style: normal;
    font-weight: 700;
    line-height: 100%;
    margin: 0 auto;
`;



export const formCss = css`
 
    display: flex;
    /*width: 1200px;*/
    width: 100%;
    max-width: 1200px;
    padding: 120px 0px;
    flex-direction: column;
    margin: 0 auto;
    gap: 60px;
    
    
    .Maintitle {
        color: #000;
        font-size: 32px;
        font-style: normal;
        font-weight: 700;
        line-height: 100%;
    }
`;


export const formInputCss = css`
    width: 100%;
    height: 100%;
    gap: 60px;
    display: flex;
    flex-direction: column;
    
    
    .title {
        font-weight: 700;
        color : #1E1E1E;
        font-size: 24px;
        
        @media (max-width: 640px) {
            font-size: 18px;
        }
    }
    .point {
        color: #19CF7A;
        font-weight: 700;
    }
    
    .subTitle {
        color : #1E1E1E;
        font-size: 20px;
        font-weight: 600;
        margin-bottom: 4px;
        
        @media (max-width: 640px) {
            font-size: 16px;
        }
    }
    
    .subMsg {
        color: #B3261E;
        font-weight: 400;
        font-size: 16px;
        margin-top: 8px;
    }

   /* input[type="checkbox"]:checked {
        background-color: #ff8955;
        border-color: rgba(255, 255, 255, 0.3);
        color: white;
    }*/
`;

export const creativeProcessCss = css`
    display: flex;
    flex-direction: column;
    gap: 12px;

    p {
        margin: 0;
    }

    ul, .ck-content ul {
        list-style-type: disc !important;
        padding-left: 24px !important;
        margin-bottom: 8px !important;
    }
    ol, .ck-content ol {
        list-style-type: decimal !important;
        padding-left: 24px !important;
        margin-bottom: 8px !important;
    }
    li, .ck-content li {
        display: list-item !important;
    }
    em, i, .ck-content em, .ck-content i {
        font-style: italic !important;
    }
    strong, b, .ck-content strong, .ck-content b {
        font-weight: 800 !important;
    }

    .ck-figure-row {
        display: flex;
        flex-direction: row;
        gap: 12px;
        padding-top: 16px;
        border-top: 1px solid rgba(229, 236, 232, 0.6);
        overflow-x: auto;
    }

    /* 이미지 stagger용 motion wrapper */
    .ck-figure-row > .fig-wrapper {
        flex: 1;
        min-width: 0;
    }
    .ck-figure-row > .fig-wrapper figure.image {
        flex: none;
        width: 100%;
    }

    figure.image {
        flex: 1;
        min-width: 0;
        background: white;
        border: 1px solid #e5ece8;
        border-radius: 12px;
        box-shadow: 0px 4px 12px rgba(0, 0, 0, 0.04);
        padding: 5px;
        margin: 0;
        overflow: hidden;
    }

    figure.image img {
        width: 100%;
        aspect-ratio: 1 / 1;
        object-fit: cover;
        border-radius: 8px;
        display: block;
        transition: transform 0.25s ease;
    }

    figure.image:hover img {
        transform: scale(1.05);
    }
`;

export const checkboxCss = css`

    /* index.css 또는 전역 스타일 파일에 추가 */
    .custom-checkbox {
        appearance: none;
        width: 24px;
        height: 24px;
        border: 2px solid #19cf7a;
        border-radius: 4px;
        background-color: white;
        cursor: pointer;
        position: relative;
    }

    .custom-checkbox:checked {
        background-color: #19cf7a;
        border-color: #19cf7a;
    }

    .custom-checkbox:checked::after {
        content: '✔';
        font-size: 12px;
        color: white;
        align-items: center;
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
      
    }

`;





